import { render } from "./archiveManager.vue?vue&type=template&id=61b87eea&scoped=true"
import script from "./archiveManager.vue?vue&type=script&lang=js"
export * from "./archiveManager.vue?vue&type=script&lang=js"

import "./archiveManager.vue?vue&type=style&index=0&id=61b87eea&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b87eea"]])

export default __exports__